import { render, staticRenderFns } from "./page-preview.vue?vue&type=template&id=d61c52f8&"
import script from "./page-preview.vue?vue&type=script&lang=js&"
export * from "./page-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports